// @mui material components
import Card from "@mui/material/Card";
import Homework from "../../../../components/Homework";

function StudentHomework() {
  return (
    <Card>
      <Homework />
    </Card>
  );
}

export default StudentHomework;
